class ClickReveal extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('[data-click-reveal-overlay]');
    this.activeModal = null;
    this.lastFocused = null;

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-click-reveal-trigger]');
      if (trigger) {
        this.open(trigger.dataset.clickRevealTrigger);
        return;
      }

      if (event.target.closest('[data-click-reveal-close]') || event.target === this.overlay) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.activeModal) this.close();
    });
  }

  open(modalId) {
    if (!modalId) return;
    const modal = this.querySelector(`#${modalId}`);
    if (!modal || !this.overlay) return;

    if (this.activeModal) this.activeModal.hidden = true;

    this.lastFocused = document.activeElement;
    this.activeModal = modal;
    this.overlay.hidden = false;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    modal.focus();
  }

  close() {
    if (!this.activeModal || !this.overlay) return;

    this.activeModal.hidden = true;
    this.activeModal = null;
    this.overlay.hidden = true;
    document.body.style.overflow = '';

    if (this.lastFocused) this.lastFocused.focus();
  }
}

if (!customElements.get('click-reveal')) {
  customElements.define('click-reveal', ClickReveal);
}
